/* eslint-disable */
import $ from 'jquery';

(function($, window, document, undefined){
  var defaults = {
    enabledClass: 'accordion--enabled',
    activeClass: 'is--active',
  };

  var Accordion = function(element, options) {
    this.el = element;
    this.options = options;
    this.$el = $(this.el);

    this.options = $.extend({}, defaults, options);
    this.options = $.extend({}, this.options, this.$el.data());

    this.$elTitles = this.$el.find('.accordion__title');
    this.$elContents = this.$el.find('.accordion__content');

    this.$el.addClass(this.options.enabledClass);

    this.init();
  };

  $.extend(Accordion.prototype, {
    init: function() {
      this.prepareMarkup();
    },
    prepareMarkup: function() {
      this.$elTitles.on('click.Accordion', $.proxy(this.onClick, this));
    },
    onClick: function(event){
      var $el = $(event.delegateTarget);
      var $elCurrentTitle = this.$elTitles.filter('.' + this.options.activeClass);
      var $elCurrentContent = this.$elContents.filter('.' + this.options.activeClass);

      if ($el !== $elCurrentTitle) {
        $el.addClass(this.options.activeClass);
        $el.next().stop().slideDown();
        $el.next().addClass(this.options.activeClass);
      }
      $elCurrentTitle.removeClass(this.options.activeClass);
      $elCurrentContent.stop().slideUp();
      $elCurrentContent.removeClass(this.options.activeClass);
      $.fn.matchHeight._update();
    },
    onSlideUp: function($elTitle, $elContent){

    },
    onSlideDown: function($elTitle, $elContent){

    }
  });

  function jqAccordion(options) {
    return this.each(function() {
      var returnValue = null;
      if (!$.data(this, 'Accordion')) {
        returnValue = $.data(this, 'Accordion', new Accordion(this, options));
      } else {
        returnValue = $.data(this, 'Accordion');
      }
      return returnValue;
    });
  }

  $.fn.Accordion = jqAccordion;

  $('.accordion').Accordion();
})($, window, document);



// WEBPACK FOOTER //
// ./assets/js/components/accordion.js